import { Pipe, PipeTransform, Injectable } from '@angular/core';

@Pipe({
    name: 'localeNumber',
    pure: false // Make it impure so it re-evaluates on every change detection cycle
    ,
    standalone: false
})
@Injectable()
export class LocaleNumberPipe implements PipeTransform {
  constructor() {}

  transform(value: string | number, format: string = '1.2-2'): string | number {
    if (typeof value === 'string') {
      if (value.includes('/') || value.includes('%') || 
          value.includes('$') || value.includes(' ')) {
        return value;
      }
      const numValue = parseFloat(value);
      if (isNaN(numValue)) {
        return value;
      }
      return this.formatWithLocale(numValue, format) || value;
    }

    const numValue = Number(value);
    if (isNaN(numValue)) {
      return value;
    }

    return this.formatWithLocale(numValue, format) || value;
  }

  private formatWithLocale(value: number, format: string): string {
    try {
      // Currently will just hard code to en-US
      const currentLocale = 'en-US';
      
      // Parse the format string to get digits info
      const digitsInfo = format || '1.2-2';
      const [minIntegerDigits, minFractionDigits, maxFractionDigits] = digitsInfo.split('.').map(part => {
        if (part.includes('-')) {
          const [min, max] = part.split('-');
          return { min: parseInt(min), max: parseInt(max) };
        }
        return { min: parseInt(part), max: parseInt(part) };
      });

      return new Intl.NumberFormat(currentLocale, {
        minimumIntegerDigits: minIntegerDigits?.min || 1,
        minimumFractionDigits: minFractionDigits?.min || 2,
        maximumFractionDigits: maxFractionDigits?.max || 2
      }).format(value);
    } catch (error) {
      // Fallback to default formatting if locale is not supported
      return new Intl.NumberFormat('en-US', {
        minimumIntegerDigits: 1,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(value);
    }
  }
}
